module.exports = __webpack_public_path__ + "img/hr-dead-dry-hairy-tree-09.2fd30b7f.png";